import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import EmptyState from '../../EmptyState';
import { Supporters, Props as WidgetProps } from './Supporters';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';

import s from './SupportersBox.scss';

const SupportersBox: React.FC<
  WidgetProps &
    WidgetBoxProps & {
      isOwner: boolean;
      profileOwnerUser: PapiUser;
    }
> = ({
  isEmpty,
  isOwner,
  widgetRemove,
  widgetMoveUp,
  widgetMoveDown,
  widgetMenuRenderer,
  profileOwnerUser,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const onClickEmptyStateCta = () => {
    window.location.href = t('widgets.supporters.empty.CTALink.owner');
  };
  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t('widgets.supporters.header')}
      hasMore={false}
      moduleId={props.moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        isOwner ? (
          <EmptyState
            view="small"
            className={s['empty-state']}
            title={t('widgets.supporters.empty.title.owner')}
            subtitle={t('widgets.supporters.empty.subtitle.owner')}
            buttonLabel={t('widgets.supporters.empty.CTALabel.owner')}
            withButton={true}
            onButtonClick={onClickEmptyStateCta}
          />
        ) : (
          <EmptyState
            view="small"
            className={s['empty-state']}
            title={t('widgets.supporters.empty.title.visitor')}
            subtitle={t('widgets.supporters.empty.subtitle.visitor', {
              username: profileOwnerUser.username,
            })}
          />
        )
      }
    >
      <Supporters moduleId={props.moduleId} deviants={props.deviants} />
    </WidgetBox>
  );
};
SupportersBox.displayName = 'SupportersBox';

export default SupportersBox;
